module.exports = __webpack_public_path__ + "./assets/icons/reddit.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/redditIcon.svg
// module id = 164
// module chunks = 0 1